<section class="control-data-export-form">
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form && isNew) {
    <form class="control-data-export-form__form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <div class="astral-layout-item">
            <app-autocomplete-remote-paged
              [defaultSearch]="'*'"
              [control]="form.controls['companyId']"
              [service]="companyService"
            ></app-autocomplete-remote-paged>
          </div>
          <astral-input [control]="form.controls['incomeYear']" [type]="'number'" [inputMode]="'numeric'"></astral-input>
          <astral-textarea class="astral-grid-full" [control]="form.controls['comment']"></astral-textarea>
        </astral-layout-group>
      </section>
    </form>
  }
  @if (form && !isNew) {
    <form class="control-data-export-form__form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['companyName']"></astral-input>
          <astral-input [control]="form.controls['incomeYear']" [type]="'number'" [inputMode]="'numeric'"></astral-input>
          <astral-input [control]="form.controls['createdAt']"></astral-input>
          <astral-textarea class="astral-grid-full" [control]="form.controls['comment']"></astral-textarea>
        </astral-layout-group>
      </section>

      <section class="astral-stack-m">
        <h4>{{ 'CONTROL_DATA.EXPORT_FILES' | translate }}</h4>

        <div class="astral-accordion-stack">
          @for (file of $any(files.controls); track file; let i = $index) {
            <astral-accordion [header]="file.controls['caption'].value" [translateHeader]="false">
              <div class="astral-stack-l">
                <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [alignItems]="'center'">
                  <astral-checkbox [control]="file.controls['sentToTaxAuthorityAt']"></astral-checkbox>
                  <div class="astral-form-adjacent-action">
                    <astral-button
                      variant="primary"
                      type="button"
                      icon="download"
                      labelKey="DOWNLOAD_BTN"
                      [disabled]="downloading"
                      (click)="download(file.controls['id'].value)"
                    ></astral-button>
                  </div>
                  <astral-textarea class="astral-grid-full" [control]="file.controls['comment']"></astral-textarea>
                </astral-layout-group>

                <control-data-form-list [id]="i" [file]="dataContext.files[i].forms"></control-data-form-list>
              </div>
            </astral-accordion>
          }
        </div>
      </section>
    </form>
  }
</section>
